import { AlertMessage } from '@/core/tamagoshi/AlertMessage/AlertMessage';
import { Text } from '@/core/tamagoshi/Text/Text';

import {
  addToWishlistFailText,
  addToWishlistSuccessCta,
  addToWishlistSuccessText,
  addToWishlistTitle,
} from '../translations';

export const useOperationFeedback = (
  listName: string,
  severity: 'success' | 'danger',
) => {
  const isSuccess = severity === 'success';
  const message = isSuccess ? addToWishlistSuccessText : addToWishlistFailText;
  const body = (
    <AlertMessage fullWidth message={message} severity={severity}>
      {isSuccess && (
        <Text tag="span" weight="bold">
          {` ${listName}`}
        </Text>
      )}
    </AlertMessage>
  );

  return {
    body,
    title: addToWishlistTitle,
    actionButtonText: addToWishlistSuccessCta,
    showSecondaryButton: false,
  };
};
